<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">

        <div class="popup-title mr-auto" *ngIf="!fromHistory" translate>
          <ng-container *ngIf="fromWorkOrder;else loadelse" translate>lblView</ng-container>
          <ng-template #loadelse>
            lblEditVehicleDetails
          </ng-template>
        </div>
        <div class="popup-title mr-auto" *ngIf="fromHistory" translate>
          lblHistory
        </div>
        <div class="float-right">
          <a class="close mr-2" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>

      <div *ngIf="fromHistory">
        <div>
          <ul ngbNav #nav="ngbNav" class="nav-tabs bg-grey">
            <li *ngFor="let tab of historyTab" class="nav-item">
              <a
                translate
                class="nav-link"
                (click)="selectedtab = tab.id"
                [ngClass]="{ active: selectedtab === tab.id }"
                >{{ tab.label }}</a
              >
            </li>
          </ul>
        </div>
        <ng-cotainer *ngIf="selectedtab === 1">
          <app-appointment-work-order-history></app-appointment-work-order-history>
        </ng-cotainer>
      </div>

      <div *ngIf="!fromHistory">
        <div class="d-flex align-items-center justify-content-between bg-grey">
          <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li *ngFor="let tab of tabs; let i = index" class="nav-item">
              <a
                translate
                class="nav-link"
                (click)="tabSelected(tab.id)"
                [ngClass]="{ active: selectedtab === tab.id }"
                >{{ tab.label }}</a
              >
            </li>
          </ul>
          <div class="fs-16px mr-4">
            <ng-cotainer class="clrBlue semibold">
              <em class="fas fa-car mr-2"></em>{{licensePlate}} - {{make}} - {{model}}</ng-cotainer>
          </div>
        </div>
        <ng-cotainer *ngIf="selectedtab === 1">
          <app-vehicle-list
            [IsSearch]="IsSearch"
            [EditVehicleId]="vehicleId"
            [EditLicensePlate]="licensePlate"
            [FromWorkOrder] ="fromWorkOrder"
          ></app-vehicle-list>
        </ng-cotainer>
        <ng-cotainer *ngIf="selectedtab === 2">
          <app-customer-detail></app-customer-detail>
        </ng-cotainer>
        <ng-cotainer *ngIf="selectedtab === 3">
          <app-appointment-work-order-history></app-appointment-work-order-history>
        </ng-cotainer>
        <ng-cotainer *ngIf="selectedtab === 4">
          <app-vehicle-ownership-history [licensePlate]="licensePlate"></app-vehicle-ownership-history>
        </ng-cotainer>
      </div>
    </div>
  </div>
</div>
